import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "col-md-6 pl-md-4",
  id: "team-list"
}
const _hoisted_2 = {
  class: "d-flex flex-wrap",
  id: "teams-tab-row"
}
const _hoisted_3 = {
  class: "nav nav-pills flex-nowrap flex-grow-1 pb-2",
  role: "tablist",
  id: "nav-teams"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "d-flex pt-3" }
const _hoisted_8 = {
  id: "teams-all",
  class: "tab-content"
}
const _hoisted_9 = {
  class: "tab-pane fade show active",
  id: "team-own",
  role: "tabpanel",
  "aria-labelledby": "tab-team-own"
}
const _hoisted_10 = {
  class: "list-group",
  id: "team-own-list"
}
const _hoisted_11 = { class: "d-flex w-100" }
const _hoisted_12 = { class: "team-left" }
const _hoisted_13 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "list-group tab-pane fade",
  id: "team-member",
  role: "tabpanel",
  "aria-labelledby": "tab-team-member"
}
const _hoisted_18 = { class: "d-flex w-100" }
const _hoisted_19 = { class: "team-left p-2" }
const _hoisted_20 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = { class: "mb-1" }
const _hoisted_23 = { class: "team-right p-2" }
const _hoisted_24 = {
  id: "leave-team-button",
  "data-toggle": "modal",
  "data-target": "#modal-leave-team",
  class: "btn btn-remove-team btn-menu btn-outline-secondary",
  title: "Leave this team"
}
const _hoisted_25 = {
  class: "list-group tab-pane fade",
  id: "team-invite",
  role: "tabpanel",
  "aria-labelledby": "tab-team-invite"
}
const _hoisted_26 = { class: "d-flex w-100 justify-content-center align-items-center" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "d-flex w-100 justify-content-center mt-2 mb-3" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "d-flex w-100 justify-content-center" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "justify-content-center" }
const _hoisted_35 = { class: "mt-3 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeamNewModal = _resolveComponent("TeamNewModal")!
  const _component_TeamLeaveModal = _resolveComponent("TeamLeaveModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h4", null, "My Teams")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: "nav-link active",
            href: "#team-own",
            id: "tab-team-own",
            "data-toggle": "pill",
            "aria-controls": "team-own",
            "aria-selected": "true",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchToOwnSelectionModel && _ctx.switchToOwnSelectionModel(...args)))
          }, "Owner")
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#team-member",
            id: "tab-team-member",
            "data-toggle": "pill",
            "aria-controls": "team-member",
            "aria-selected": "false",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchToMemberSelectionModel && _ctx.switchToMemberSelectionModel(...args)))
          }, "Member")
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#team-invite",
            id: "tab-team-invite",
            "data-toggle": "pill",
            "aria-controls": "team-invite",
            "aria-selected": "false",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchToInviteSelectionModel && _ctx.switchToInviteSelectionModel(...args)))
          }, "Invited")
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "flex-wrap d-flex align-items-baseline",
        style: {"flex":"1"}
      }, [
        _createElementVNode("button", {
          type: "button",
          role: "button",
          "data-toggle": "modal",
          "data-target": "#modal-new-team",
          class: "btn btn-attention btn-new-item pull-right w-100",
          id: "btn-new-team"
        }, " New Team ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.hasOwnedTeams)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({'d-block': _ctx.hasOwnedTeams, 'd-none': !_ctx.hasOwnedTeams})
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownedTeams, (t) => {
                    return (_openBlock(), _createElementBlock("a", _mergeProps({
                      href: "javascript:void(0)",
                      class: "list-group-item list-group-item-action flex-column align-items-start",
                      key: t.refid
                    }, { ref_for: true }, {'data-team': t.refid}), [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("h5", _hoisted_14, _toDisplayString(t.name), 1)
                          ]),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(t.description), 1),
                          (t.budget)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_16, "Charges this month: " + _toDisplayString(t.budget.charges) + "/" + _toDisplayString(t.budget.monthlyLimit), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 16))
                  }), 128))
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fellowTeams, (t) => {
            return (_openBlock(), _createElementBlock("a", _mergeProps({
              href: "javascript:void(0)",
              class: "list-group-item list-group-item-action flex-column align-items-start",
              key: t.refid
            }, { ref_for: true }, {'data-team': t.refid}), [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("h5", _hoisted_21, _toDisplayString(t.name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(t.description), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("small", null, null, -1))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("button", _hoisted_24, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
                  ]))], 512), [
                    [_vShow, !_ctx.isOwnedTeam(t.refid)]
                  ])
                ])
              ])
            ], 16))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openInvites, (ivt) => {
            return (_openBlock(), _createElementBlock("a", _mergeProps({
              href: "javascript:void(0)",
              class: "list-group-item list-group-item-action flex-column align-items-start team-list-item"
            }, { ref_for: true }, {'data-invite': ivt.code}), [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("i", {
                  class: "fa fa-3x fa-users",
                  title: ivt.team.description
                }, null, 8, _hoisted_27),
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-2x fa-plus ml-2 mr-2" }, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-3x fa-user" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("p", null, "You're invited to join the team " + _toDisplayString(ivt.team.name) + "! ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn btn-attention mr-1",
                  onClick: ($event: any) => (_ctx.joinTeam(ivt.code))
                }, "Accept", 8, _hoisted_31),
                _createElementVNode("button", {
                  class: "btn btn-secondary ml-1",
                  onClick: ($event: any) => (_ctx.cancelInvitation(ivt.code))
                }, "Decline", 8, _hoisted_32)
              ])
            ], 16))
          }), 256)),
          _withDirectives(_createElementVNode("div", _hoisted_33, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "fa fa-10x fa-ban mt-5 mb-2" }, null, -1),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("p", { class: "text-muted text-center" }, [
              _createTextVNode("It is empty here. You have no open invitations. What about creating your own team?"),
              _createElementVNode("br"),
              _createElementVNode("a", {
                href: "https://help.ganttproject.biz/t/inviting-collaborators",
                target: "_blank"
              }, "Learn more")
            ], -1)
          ]))], 512), [
            [_vShow, _ctx.openInvites.length === 0]
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_34, [...(_cache[9] || (_cache[9] = [
      _createElementVNode("div", { class: "text-center" }, [
        _createElementVNode("i", { class: "fa fa-10x fa-users mt-5 mb-2" }),
        _createElementVNode("br"),
        _createElementVNode("button", {
          type: "button",
          role: "button",
          "data-toggle": "modal",
          "data-target": "#modal-new-team",
          class: "btn btn-attention btn-new-item fa-2x",
          id: "btn-new-team"
        }, " Create New Team ")
      ], -1)
    ]))], 512), [
      [_vShow, _ctx.hasHelpCard]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_35, [...(_cache[10] || (_cache[10] = [
      _createElementVNode("p", { class: "text-muted text-center" }, [
        _createTextVNode("Team is a group of people working on the same projects."),
        _createElementVNode("br"),
        _createElementVNode("a", {
          href: "https://help.ganttproject.biz/t/what-is-a-team-in-ganttproject-cloud",
          target: "_blank"
        }, "Learn more")
      ], -1)
    ]))], 512), [
      [_vShow, _ctx.hasHelpCard]
    ]),
    _createVNode(_component_TeamNewModal, { "dashboard-refresh": _ctx.onNewTeamDashboardRefresh }, null, 8, ["dashboard-refresh"]),
    _createVNode(_component_TeamLeaveModal, {
      "dashboard-refresh": _ctx.showFellowTeams,
      team: _ctx.team
    }, null, 8, ["dashboard-refresh", "team"])
  ]))
}